var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M31.3553 16C31.3553 24.4438 24.5102 31.2889 16.0664 31.2889C7.62259 31.2889 0.777517 24.4438 0.777517 16C0.777517 7.55618 7.62259 0.711111 16.0664 0.711111C24.5102 0.711111 31.3553 7.55618 31.3553 16Z",
    stroke: "#0A142F",
    strokeWidth: 1.42222
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8829 12.3338C21.3701 12.4628 21.7538 12.8407 21.8846 13.3197C22.1273 14.1939 22.116 16.0166 22.116 16.0166C22.116 16.0166 22.1143 17.8292 21.8789 18.7029C21.7465 19.1813 21.361 19.5587 20.8744 19.6871C19.9842 19.916 16.4226 19.9121 16.4226 19.9121C16.4226 19.9121 12.8707 19.9082 11.9713 19.6681C11.4836 19.5391 11.0998 19.1612 10.9691 18.6828C10.736 17.8175 10.7383 15.9954 10.7383 15.9954C10.7383 15.9954 10.7406 14.1822 10.9753 13.308C11.1072 12.8295 11.5018 12.4432 11.9793 12.3154C12.8701 12.0859 16.4311 12.0898 16.4311 12.0898C16.4311 12.0898 19.9927 12.0938 20.8829 12.3338ZM15.2958 14.3262L15.293 17.6757L18.2559 16.0037L15.2958 14.3262Z",
    fill: "#0A142F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.0b56720fdf7f4913d04c89556b5f7f0d.svg";
export { ForwardRef as ReactComponent };